import React, { useEffect, useState } from 'react';
import WaAdminShell from '../../components/admin/whatsapp/WaAdminShell';
import WaSimulatorChat from '../../components/admin/whatsapp/WaSimulatorChat';
import { fetchWaAgents } from '../../utils/adminWhatsapp';

export default function WhatsAppSimulator() {
  const [phones, setPhones] = useState([]);

  useEffect(() => {
    fetchWaAgents()
      .then((r) => setPhones(r.agents || []))
      .catch(() => setPhones([]));
  }, []);

  const defaultPhone = phones[0]?.phone || '';

  return (
    <WaAdminShell title="Sandbox chat" subtitle="Test the full bot without Interakt or a real phone">
      <p className="text-sm text-gray-600 mb-4">
        Messages run through the same booking engine as production. Outbound is mocked (logged to DB only).
        Use a sandbox number from the Sandbox tab or any E.164 test phone.
      </p>
      <WaSimulatorChat phones={phones} defaultPhone={defaultPhone} />
    </WaAdminShell>
  );
}
